
import _ from 'lodash';
import {setDefaults} from "@/router/helper";


const _import = require('@/libs/util.import.' + process.env.NODE_ENV)


const sampleCheckForm = () => import('@/views/proof/sampleCheckForm.vue');
const proofCenter = () => import('@/views/proof/proofCenter.vue');

//这是打样，订单里的打样信息，和打样中心的打样。在内容上相近，

const routes = [
  {
    path: 'samplecheck/:id',
    meta: {
      title: '审核样',
    },
    component: _import('proof/sampleCheckForm.vue'),
  },
  {
    path: 'proofCenter',
    meta: {
      title: '打样中心',
    },
    component: _import('proof/proofCenter.vue'),
  },
  {
    path: 'accounting',
    meta: {
      title: '面料核算',
    },
    component: _import('proof/accounting.vue'),
  },
];


// export default [
//   {
//     path: '/samplecheck/:id',
//     component: sampleCheckForm,
//   },
//   {
//     path:'/proofCenter',
//     component:proofCenter,
//   }
// ];
//

export default setDefaults(routes);
